const KEY = 'EXISTING_TIME_USER'

export const saveExistingTimeUserToStorage = (value: string) => {
  localStorage.setItem(KEY, value);
}

export const loadExistingTimeUserFromStorage = (): string | null => {
  return localStorage.getItem(KEY);
}
